/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {React,useEffect,useState,useAuth0, Container,Grid,Card,CardHeader,CardContent,Typography,CircularProgress,Alert,CardMedia,IconButton,CardActions,Box,Modal,MenuItem,MenuList,Button,styled,FavoriteIcon,FavoriteBorderIcon,CommentIcon,ShareIcon,SaveIcon,MoreVertIcon,Avatar,Comments,ShareForm,AboutPet} from './imports';
import { StyledCard, StyledCardMedia, StyledCardVideo } from './styledComponents';
import likePostHome from './likePostHome';
import savePost from './savePost';
import likeComment from './likeComment';
import handleFollowUser from './handleFollowUser';
import { handleSharePost } from './handleSharePost';
import {PersonAdd} from "@mui/icons-material";
import { fetchSearchResults } from './searchHelper';
import { fetchPetOwnerProfileHelper } from './fetchPetOwnerProfileHelper';
import { getPetOwnerName } from './getPetOwnerNameHelper';
import fetchLikedPosts from './fetchLikedPosts';
import fetchSavedPosts from './fetchSavedPosts';
import fetchFollowedUsers from './fetchFollowedUsers';
import {
    FacebookIcon,
    FacebookShareButton,
    PinterestIcon,
    PinterestShareButton,
    TwitterShareButton,
    XIcon
} from "react-share";
import Tooltip from '@mui/material/Tooltip';
import { keyframes } from '@mui/system';
import './sharedButtons.css'

const rainbowAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;


const Home = ({ filterPosts, searchString }) => {
    const { user, isAuthenticated } = useAuth0();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [likedPosts, setLikedPosts] = useState({}); // new state to keep track of liked posts
    const [savedPosts, setSavedPosts] = useState({});
    const [commentsOpen, setCommentsOpen] = useState(false);
    const [currentPostId, setCurrentPostId] = useState(null);
    const [likedComments, setLikedComments] = useState({});
    const [followedUsers, setFollowedUsers] = useState({});
    const [shareFormOpen, setShareFormOpen] = useState(false);
    const [currentPostToShare, setCurrentPostToShare] = useState(null);
    const [aboutPetOpen, setAboutPetOpen] = useState(false);
    const [currentPet, setCurrentPet] = useState(null);
    const [likeCounts, setLikeCounts] = useState({});
    const [petOwnerName, setPetOwnerName] = useState('');
    const [hasFetched, setHasFetched] = useState(false);
    const [petOwnerProfile, setPetOwnerProfile] = useState({
        name: '',
        bio: '',
        fileUrl: '',
    });
    const [searchResults, setSearchResults] = useState([]);

    const iconButtonSx = {
        transition: 'transform 0.3s ease-in-out',
        '&:hover': {
            transform: 'scale(2.0)',
        },
        '& .MuiSvgIcon-root': { // Target the icon inside the IconButton
            transition: 'color 0.3s ease-in-out',
        },
        '&:hover .MuiSvgIcon-root': {
            color: '#68FF00',
        },
    };

    const openComments = (postId) => {
        setCurrentPostId(postId);
        setCommentsOpen(true);
    };
    const closeComments = () => {
        setCurrentPostId(null);
        setCommentsOpen(false);
    };
    const handleLikeComment = (postId, commentId) => {
        likeComment(user.email, postId, commentId, setLikedComments);
    };

    const handlePostSharing = (shareToEmail) => {
        handleSharePost(shareToEmail, user, currentPostToShare);
    };

    const handleAboutPet = (pet, id) => {
        setCurrentPet(pet);
        setCurrentPostId(id);
        setAboutPetOpen(true);
    };

    useEffect(() => {
        fetchSearchResults(searchString, setSearchResults);
    }, [searchString]);

    useEffect(() => {
        //console.log(searchResults);
    }, [searchResults]);


    useEffect(() => {
        const fetchPetOwnerProfile = async () => {
            if (isAuthenticated && user) {
                const petOwnerProfileData = await fetchPetOwnerProfileHelper(user.email);
                if (petOwnerProfileData) {
                    setPetOwnerProfile(petOwnerProfileData);
                }
            }
        };

        fetchPetOwnerProfile();
    }, [user, isAuthenticated]);

    useEffect(() => {
        const fetchPosts = async () => {
            setLoading(true);
            try {
                const response = await fetch('/.netlify/functions/listPosts');
                if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}`);
                }

                let data = await response.json();

                // If searchResults is not empty, filter the posts based on the search results
                if (searchResults.length > 0) {
                    data = data.filter(post => searchResults.includes(post.id));
                    //console.log(data)
                }

                // Filter posts if filterPosts is provided and not empty
                if (filterPosts) {
                    if (filterPosts.length > 0) {
                        // If filterPosts is not empty, filter the posts
                        data = data.filter(post => filterPosts.includes(post.id));
                    } else {
                        // If filterPosts is empty, show no posts
                        data = [];
                    }
                }

                setPosts(data);
                setLoading(false);
                setHasFetched(true);

                // fetch the liked posts only if the user is authenticated
                if (isAuthenticated && user) {

                    try {
                        const petOwnerNameData = await getPetOwnerName(user.email);
                        setPetOwnerName(petOwnerNameData);
                    } catch (error) {
                        console.error(error);
                    }

                    fetchLikedPosts(user.email, setLikedPosts);

                    fetchSavedPosts(user.email, setSavedPosts);

                    // fetch the liked comments
                    const likedCommentsResponse = await fetch('/.netlify/functions/getLikedComments', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userEmail: user.email }),
                    });

                    if (!likedCommentsResponse.ok) {
                        throw new Error(`HTTP error ${likedCommentsResponse.status}`);
                    }

                    const likedCommentsData = await likedCommentsResponse.json();

                    // set the liked comments state
                    let likedCommentsObj = {};
                    likedCommentsData.forEach(commentId => {
                        likedCommentsObj[commentId] = true;
                    });
                    setLikedComments(likedCommentsObj);

                    // Fetch the followed owners
                    fetchFollowedUsers(user.email, setFollowedUsers);

                }
            } catch (error) {
                console.error('Error fetching posts:', error);
                setError(error.message);
                setLoading(false);
                setHasFetched(true);
            }
        };

        fetchPosts();
    }, [isAuthenticated, user, filterPosts, searchResults]);

    return (
        <Container maxWidth="md">
            <Typography variant="h6" sx={{
                marginBottom: 6,
                color:'#15a2fa'
            }}>
                {/*{`Playing fetch in the park is my favorite!`}*/}
            </Typography>

            {isAuthenticated && user && (
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', mt: 2, mb: 4 }}>

                    <Avatar
                        alt={petOwnerProfile.name || ''}
                        src={petOwnerProfile.fileUrl || user.picture}
                        sx={{ width: 40, height: 40, marginRight: '1rem' }}
                    />
                    <Typography variant="h6" sx={{
                        color:'#16cc7d'
                    }}>
                        {petOwnerName}
                    </Typography>
                </Box>
            )}

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {`Error fetching data: ${error}`}
                </Alert>
            )}
            <Grid container spacing={2} justifyContent="center">
                {loading ? (
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Grid>
                ) : (
                    <>
                        {posts.length > 0 ? (
                            posts.map(({ id, caption, pet, owner, fileUrl }) => (
                                <Grid item xs={12} key={id}>
                                    <StyledCard
                                        sx={{
                                            border: '2px solid #FFFFFF00'
                                        }}
                                    >
                                        <CardHeader
                                            action={
                                                <IconButton onClick={() => handleAboutPet(pet, id)}>
                                                    <MoreVertIcon style={{ color: '#e91e63' }}/>
                                                </IconButton>
                                            }
                                            sx={{
                                                '& .MuiCardHeader-title': {  // <-- this targets the title
                                                    color: '#16cc7d'
                                                },
                                                '& .MuiCardHeader-subheader': {  // <-- this targets the subheader
                                                    color: '#9ca3af'
                                                }
                                            }}
                                            title={`${pet ? pet.name : 'Unknown'}`}
                                            subheader={`by: ${owner ? owner.name : 'Unknown'}`}
                                        />
                                        {fileUrl && fileUrl.endsWith('.mp4') ? (
                                            <StyledCardVideo controls>
                                                <source src={fileUrl} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </StyledCardVideo>
                                        ) : (
                                            <StyledCardMedia
                                                image={fileUrl ? fileUrl : "https://via.placeholder.com/640x360"}
                                                title="Post image"
                                            />
                                        )}
                                        <CardContent>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    color:'#333333'
                                                }}
                                            >{caption}
                                            </Typography>
                                        </CardContent>
                                        <CardActions
                                            disableSpacing
                                            sx={{ display: 'flex', justifyContent: 'space-around', padding: '10px' }}
                                        >
                                            {/* Add to favorites button */}
                                            <Tooltip title="Add to favorites">
                                                <IconButton
                                                    aria-label="add to favorites"
                                                    onClick={() => likePostHome(user, id, likedPosts[id], setLikedPosts, setLikeCounts)}
                                                    sx={iconButtonSx}
                                                >
                                                    {likedPosts[id] ? <FavoriteIcon sx={{ color: likedPosts[id] ? '#e91e63' : '#607d8b' }}/> : <FavoriteBorderIcon sx={{ color: '#607d8b' }}/>}
                                                </IconButton>
                                            </Tooltip>

                                            {/* Comment button */}
                                            <Tooltip title="Comment">
                                                <IconButton
                                                    aria-label="comment"
                                                    onClick={() => openComments(id)}
                                                    sx={iconButtonSx}
                                                >
                                                    <CommentIcon sx={{ color: '#607d8b' }}/>
                                                </IconButton>
                                            </Tooltip>

                                            {/* Share button */}
                                            <Tooltip title="Share">
                                                <IconButton
                                                    aria-label="share"
                                                    onClick={() => {setCurrentPostToShare(id); setShareFormOpen(true);}}
                                                    sx={iconButtonSx}
                                                >
                                                    <ShareIcon sx={{ color: '#607d8b' }}/>
                                                </IconButton>
                                            </Tooltip>

                                            {/* Save button */}
                                            <Tooltip title="Save">
                                                <IconButton
                                                    aria-label="save"
                                                    onClick={() => savePost(user, id, savedPosts[id], setSavedPosts)}
                                                    sx={iconButtonSx}
                                                >
                                                    {savedPosts[id] ? <SaveIcon sx={{ color: '#15a2fa' }}/> : <SaveIcon sx={{ color: '#607d8b' }}/>}
                                                </IconButton>
                                            </Tooltip>

                                            {/* Follow button */}
                                            <Tooltip title="Follow">
                                                <IconButton
                                                    aria-label="follow"
                                                    onClick={() => handleFollowUser(owner.hashEmail, user, followedUsers, setFollowedUsers)}
                                                    sx={{
                                                        ...iconButtonSx,
                                                        marginRight: '8px', // Add marginRight specifically for this button
                                                    }}
                                                >
                                                    {followedUsers[owner.hashEmail] ? <PersonAdd sx={{ color: '#15a2fa' }}/> : <PersonAdd sx={{ color: '#607d8b' }}/>}
                                                </IconButton>
                                            </Tooltip>

                                            <PinterestShareButton
                                                url={`https://wagzters.com/postprofile/${id}`}
                                                media={fileUrl ? fileUrl : "https://via.placeholder.com/640x360"}
                                                description={"Check out this post on Wagzters!"}
                                                className="shareButton"
                                                style={{ marginRight: '16px' }}
                                            >
                                                <PinterestIcon size={32} round />
                                            </PinterestShareButton>

                                            <TwitterShareButton
                                                url={`https://wagzters.com/postprofile/${id}`}
                                                title={"Check out this post on Wagzters!"}
                                                hashtags={["Wagzters", "Pets"]}
                                                className="shareButton"
                                                style={{ marginRight: '16px' }}
                                            >
                                                <XIcon size={32} round />
                                            </TwitterShareButton>

                                            <FacebookShareButton
                                                url={`https://wagzters.com/postprofile/${id}`}
                                                quote={"Check out this post on Wagzters!"}
                                                hashtag={"#Wagzters"}
                                                className="shareButton"
                                                style={{ marginRight: '16px' }}  // Add spacing between the buttons
                                            >
                                                <FacebookIcon size={32} round />
                                            </FacebookShareButton>

                                        </CardActions>
                                    </StyledCard>
                                </Grid>
                            ))
                        ) : hasFetched ? (
                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography variant="h6">
                                </Typography>
                            </Grid>
                        ) : null}
                    </>
                )}
            </Grid>

            {commentsOpen && user && (
                <Comments
                    postId={currentPostId}
                    userEmail={user.email}
                    userPicture={user.picture}
                    closeComments={closeComments}
                    likeComment={handleLikeComment}
                    likedComments={likedComments}
                    commentsOpen={commentsOpen}
                    handleClose={closeComments}
                />
            )}

            {user && (
                <ShareForm
                    open={shareFormOpen}
                    onClose={() => setShareFormOpen(false)}
                    onShare={handlePostSharing}
                />
            )}
            {aboutPetOpen && currentPet && (
                <AboutPet
                    open={aboutPetOpen}
                    onClose={() => setAboutPetOpen(false)}
                    pet={currentPet}
                    post={currentPostId}
                />
            )}
        </Container>
    );
};

export default Home;
